export const SET_CURRENT_USER = "SET_CURRENT_USER"
export const SET_LANG = "SET_LANG"
export const SET_META_DATA = "SET_META_DATA"
export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER"
export const SET_USER_REQUEST = "SET_USER_REQUEST"
export const SET_ROLE_ID = "SET_ROLE_ID"
export const SET_GOVERNATES = "SET_GOVERNATES"
export const SET_CITIES = "SET_CITIES"
export const SET_CURRENT_CLIENT = "SET_CURRENT_CLIENT"
export const NOTIFICATION_LIST = "NOTIFICATION_LIST"
export const SET_META_DATA_INDIVIDUAL = "SET_META_DATA_INDIVIDUAL";
export const SET_CUSTOMER_ADDRESSES = "SET_CUSTOMER_ADDRESSES";
export const SET_SERVICES_DATA = "SET_SERVICES_DATA";
export const SET_FAQ_CATEGORIES = "SET_FAQ_CATEGORIES";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_TERMS_AND_CONDITIONS_PAGES = "SET_TERMS_AND_CONDITIONS_PAGES";
export const SET_COUNTRIES = "SET_COUNTRIES";
export const SET_LOADING = "SET_LOADING";
